<template>
	<v-app>
		<v-navigation-drawer
			v-model="drawer"
			temporary
			location="right"
			width="400"
		>
			<v-toolbar flat>
				<v-avatar>
					<v-icon icon="mdi-cog"></v-icon>
				</v-avatar>
				<v-toolbar-title>{{ $filters.Translate('settings') }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="drawer=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<!-- <v-row>
				<v-col>
					<v-select
						:label="$filters.Translate('language')"
						:items="languages"
					></v-select>
				</v-col>
			</v-row> -->

			<!-- <v-list>
				<v-list-subheader>{{ $filters.Translate('language') }}</v-list-subheader>
				<v-list-item>
					<v-menu>
						<template v-slot:activator="{ props }">
							<v-btn v-bind="props" variant="text" block style="justify-content: flex-start;">
								<span class="font-weight-medium">{{ $vuetify.locale.current }}</span>
								<template v-slot:prepend>
									<v-icon color="primary">mdi-translate</v-icon>
								</template>
							</v-btn>
						</template>
						<v-list>
							<v-list-item v-for="(item, key, index) in $vuetify.locale.messages" :key="index" :value="index" @click="onLocale(key)">
								<v-list-item-title class="text-button">{{ key }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-list-item>
			</v-list> -->

			<!-- <v-list> -->
				<!-- <v-list-subheader>Тема</v-list-subheader> -->
				<!-- <v-list-item
					prepend-icon="mdi-theme-light-dark"
					title="Light or dark"
				>
					<template v-slot:append>
						<v-switch 
							v-model="$vuetify.theme.global.name"
							false-value="light"
							true-value="dark" 
						></v-switch>
					</template>
				</v-list-item> -->

				<!-- <v-list-item color="primary"
					subtitle="Створити"
        			title="Страхове повідомлення"
					@click="dialog.claim=true"
				>
					<template v-slot:prepend>
						<v-icon icon="mdi-plus"></v-icon>
					</template>
				</v-list-item>
				<v-list-item color="primary"
					subtitle="На основі даних МТСБУ"
        			title="Збитковіть страхувальника"
					:to="{name: 'Loss'}"
				>
					<template v-slot:prepend>
						<v-icon icon="mdi-car"></v-icon>
					</template>
				</v-list-item> -->

				<!-- Використовувалось при останньому тестуванні -->
				<!-- <z-dialog-camera v-model="dialog.camera" multiple fullscreen @close="dialog.camera=false">
					<template v-slot:activator>
						<v-list-item color="primary"
							subtitle="Тестування камери"
							title="Камера"
							@click="dialog.camera=true"
						>
							<template v-slot:prepend>
								<v-icon icon="mdi-camera"></v-icon>
							</template>
						</v-list-item>
					</template>
				</z-dialog-camera> -->

				<!-- <v-list-item color="primary"
					subtitle="Тестування камери"
        			title="Камера"
					@click="dialog.camera=true"
				>
					<template v-slot:prepend>
						<v-icon icon="mdi-camera"></v-icon>
					</template>
				</v-list-item> -->

				<!-- Використовувалось при останньому тестуванні -->
				<!-- <v-list-item color="primary"
					subtitle="Підписання документі у Дія.Підпис"
        			title="Підпис документів"
					:to="{name: 'Sign'}"
				>
					<template v-slot:prepend>
						<v-icon icon="mdi-draw-pen"></v-icon>
					</template>
				</v-list-item> -->
			<!-- </v-list> -->

			<!-- <v-list>
				<v-list-subheader>Тема</v-list-subheader>
				<v-list-item
					prepend-icon="mdi-theme-light-dark"
					title="Light or dark"
				>
					<template v-slot:append>
						<v-switch 
							v-model="$vuetify.theme.global.name"
							false-value="light"
							true-value="dark" 
						></v-switch>
					</template>
				</v-list-item>
			</v-list> -->

			<v-divider></v-divider>
			
			<!-- <v-list>
				<v-list-subheader>OS</v-list-subheader>
				<v-list-item
					:title="device.osName"
					:subtitle="device.osVersion"
				>
					<template v-slot:prepend>
						<v-icon v-if="device.osName=='iOS'" icon="mdi-apple-ios"></v-icon>
						<v-icon v-else-if="device.osName=='Android'" icon="mdi-android"></v-icon>
						<v-icon v-else-if="device.osName=='Windows Phone'" icon="mdi-microsoft-windows"></v-icon>
						<v-icon v-else-if="device.osName=='Windows'" icon="mdi-microsoft-windows-classic"></v-icon>
						<v-icon v-else icon="mdi-compass"></v-icon>
					</template>
				</v-list-item>
			</v-list> -->

			<!-- <v-list>
				<v-list-subheader>Browser</v-list-subheader>
				<v-list-item
					:title="device.browserName"
					:subtitle="device.browserMajorVersion +' ('+device.browserFullVersion+')'"
				>
					<template v-slot:prepend>
						<v-icon v-if="device.browserName=='Chrome'" icon="mdi-google-chrome"></v-icon>
						<v-icon v-else-if="device.browserName=='Firefox'" icon="mdi-firefox"></v-icon>
						<v-icon v-else-if="device.browserName=='Opera'" icon="mdi-opera"></v-icon>
						<v-icon v-else-if="device.browserName=='Safari'" icon="mdi-apple-safari"></v-icon>
						<v-icon v-else-if="device.browserName=='Internet Explorer'" icon="mdi-microsoft-internet-explorer"></v-icon>
						<v-icon v-else-if="device.browserName=='Edge'" icon="mdi-microsoft-edge"></v-icon>
						<v-icon v-else-if="device.browserName=='Chromium'" icon="mdi-microsoft-windows-classic"></v-icon>
						<v-icon v-else-if="device.browserName=='IE'" icon="mdi-microsoft-windows-classic"></v-icon>
						<v-icon v-else-if="device.browserName=='Mobile Safari'" icon="mdi-microsoft-windows-classic"></v-icon>
						<v-icon v-else-if="device.browserName=='Edge Chromium'" icon="mdi-microsoft-windows-classic"></v-icon>
						<v-icon v-else icon="mdi-web"></v-icon>
					</template>
				</v-list-item>
			</v-list> -->
			<!-- <v-list>
				<v-list-item
					prepend-icon="mdi-resize"
					title="Photo Resize"
				>
					<template v-slot:append>
						<v-switch 
							v-model="settings.photo.resize"
						></v-switch>
					</template>
				</v-list-item>
			</v-list> -->

			<v-divider></v-divider>

			<template v-slot:append>
				<v-list>
					<v-list-item
						title="Версія"
						:subtitle="version"
						prepend-icon="mdi-tag"
					></v-list-item>
				</v-list>
			</template>
		</v-navigation-drawer>

		<v-app-bar app flat>
			<template v-slot:prepend>
				<router-link :to="{ name: 'Home'} ">
					<!-- <v-img class="d-none d-sm-block" -->
					<v-img
						:width="160"
						aspect-ratio="16/9"
						cover
						src="https://grdn.com.ua/img/content/logo.svg"
					></v-img>
				</router-link>
			</template>

			<template v-slot:append>
				<v-menu>
					<template v-slot:activator="{ props }">
						<v-btn v-bind="props" variant="text">
							<span class="font-weight-bold text-secondary d-none d-sm-block">0 800 503 114</span>
							<template v-slot:prepend>
								<v-icon color="primary">mdi-phone</v-icon>
							</template>
							<template v-slot:append>
								<v-icon class="d-none d-sm-block">mdi-chevron-down</v-icon>
							</template>
						</v-btn>
						<!-- <v-btn v-bind="props" class="d-none d-mb-none" variant="text" icon="mdi-phone"></v-btn> -->
					</template>
					<v-list>
						<v-list-item v-for="(item, index) in phones" :key="index" :value="index" :href="`tel:${item.value}`">
							<v-list-item-title>{{ item.title }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>

				<!-- Language Menu -->
				<!-- <v-menu open-on-hover>
					<template v-slot:activator="{ props }">
						<v-btn v-bind="props" variant="text">
							<span class="font-weight-medium">{{ $vuetify.locale.current }}</span>
							<template v-slot:prepend>
								<v-icon color="primary" class="d-none d-sm-block">mdi-translate</v-icon>
							</template>
							<template v-slot:append>
								<v-icon class="d-none d-sm-block">mdi-chevron-down</v-icon>
							</template>
						</v-btn>
					</template>
					<v-list>
						<v-list-item v-for="(item, key, index) in $vuetify.locale.messages" :key="index" :value="index" @click="onLocale(key)">
							<v-list-item-title class="text-button">{{ key }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu> -->

				<v-tooltip text="Налаштування" location="bottom">
					<template v-slot:activator="{ props }">
						<!-- <v-btn v-bind="props">Hover Over Me</v-btn> -->
						<!-- <v-btn v-bind="props" icon="mdi-cog" variant="text" @click.stop="drawer = !drawer"></v-btn> -->
						<v-btn v-bind="props" icon="mdi-cog" @click.stop="drawer = !drawer"></v-btn>
					</template>
				</v-tooltip>

				<!-- <v-tooltip v-if="login" text="Вихід" location="bottom">
					<template v-slot:activator="{ props }">
						<v-btn v-bind="props" icon="mdi-logout" variant="text" @click="onLogout"></v-btn>
					</template>
				</v-tooltip>
				<v-tooltip v-else text="Вхід" location="bottom">
					<template v-slot:activator="{ props }">
						<v-btn v-bind="props" icon="mdi-login" variant="text" :to="{name: 'Login'}"></v-btn>
					</template>
				</v-tooltip> -->
			</template>
		</v-app-bar>

		<v-main>
			<router-view/>
		</v-main>

		<z-dialog-claim v-model="dialog.claim"></z-dialog-claim>
		<!-- <z-dialog-camera v-model="dialog.camera" multiple fullscreen @close="dialog.camera=false"></z-dialog-camera> -->

		<z-message v-model="message"></z-message>
	</v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import zDrawerSettings from '@/components/drawers/Settings'
import zMessage from '@/components/message'
import zDialogClaim from '@/views/dialogs/Claim'
import zDialogCamera from '@/components/dialogs/Camera2'

export default {
	name: 'App',
	components: {
		zDrawerSettings, zMessage
		,zDialogClaim
		,zDialogCamera
	},

	data: () => ({
		drawer: false,
		setting: false,
		phones: [
			{ title: '0 800 503 114', value: '0800503114'},
			{ title: '38 044 333 37 10', value: '+380443333710'},
			{ title: '38 044 299 75 33', value: '+380442997533'},
		],

		dialog: {
			claim: false,
			loss: false,
			camera: false,
		}
	}),

	computed: {
		...mapGetters([ 'login', 'ClaimNumber', 'message' ]),
		...mapGetters('Claim', [ 'claim' ]),

		version() {
			return process.env.VUE_APP_VERSION;
		},

		languages() {
			let result = []

			this.$vuetify.locale.messages.forEach((item, key) => result.push({
				title: item.langname,
				value: key
			}))

			return result;
		},

		/* isLogin() {
			let token = localStorage.getItem('X-Api-Key')
			
			console.log(this.$options.name,  'isLogin', 'token', token)

			return  token ? true : false;
		}, */
	},

	created() {
		axios.defaults.baseURL = process.env.VUE_APP_API;
		axios.defaults.headers.common['Content-Type'] = 'application/json';

		// Отримання URL-параметрів 
		let params = new URLSearchParams(document.location.search);
		
		//console.log(this.$options.name,  'created', 'params', params)
		//console.log(this.$options.name,  'created', 'locale.messages', this.$vuetify.locale.messages)

		// Отримання номеру повідомлення з параметрів
		let number = params.get("number");
		if(number) {
			this.claim['number'] = number

			this.setClaimNumber(number)
			//console.log(this.$options.name,  'created', 'claim', this.claim)
			//console.log(this.$options.name,  'created', 'number', number)

			this.$router.push({ name: 'Claim' }).catch(err => {});
		}

		// Представлення: Визначення маршруту в залежності від виду страхування
		//this.Introduce()
	},

	methods: {
		...mapActions(['setLogin', 'setClaimNumber']),

		onLocale(name) {
			this.$vuetify.locale.current = name;
			localStorage.setItem('lang', name)
		},

		onLogout() {
			localStorage.removeItem("M-Api-Key");
			axios.defaults.headers.common['M-Api-Key'] = null;

			localStorage.removeItem("X-Api-Key");
			axios.defaults.headers.common['X-Api-Key'] = null;

			this.setLogin(false)

			this.$router.push({ name: 'Login' }).catch(err => {})
		},

		/* callNumber(phoneNumber) {
			window.location.href = `tel:${phoneNumber}`;
		} */
	},
}
</script>

<style>
	::-webkit-scrollbar {
		width: 5px;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #FAFAFA;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #EEEEEE;
	}
</style>